import React, { useContext, useMemo } from 'react';

import Select from '../../../../../components/select/select';
import {
  RANGE_OPTIONS,
  COMBINED_USD_TOKEN,
  COMBINED_USD_LABEL,
} from '../../../../../providers/portfolio-performance/risk/risk.constants';
import { RiskContext } from '../../../../../providers/portfolio-performance/risk';
import {
  formatTokenName,
  getCombinedUsdSymbols,
} from '../../../../../providers/portfolio-performance/risk/risk.helpers';
import { ReportFilterButtons } from '../../../../../components/report-filter-buttons';
import { RISK_TOKEN_LIST } from '../../../../../constants/reports/reports-filters';
import './styles.scss';

const FALLBACK_TOKEN = { name: '', value: '' };
const SECONDARY_VALUE = 'BTC USD';

export const RiskPanelFilters = () => {
  const {
    account,
    selectedToken,
    setSelectedToken,
    selectedRange,
    setSelectedRange,
    riskTokenType,
    setRiskTokenType,
  } = useContext(RiskContext);

  const tokenOptions = useMemo(() => {
    const perSymbol =
      account?.symbols.map((sym) => ({
        name: formatTokenName(sym),
        value: formatTokenName(sym),
      })) || [];
    // For USD-denominated accounts the combined-USD total is the correct
    // headline, so it leads the list; the individual settlement books stay
    // selectable below it.
    if (account && getCombinedUsdSymbols(account).length > 0) {
      return [{ name: COMBINED_USD_LABEL, value: COMBINED_USD_TOKEN }, ...perSymbol];
    }
    return perSymbol;
  }, [account]);

  const defaultValue = (() => {
    const priorities = [selectedToken, SECONDARY_VALUE];
    for (const val of priorities) {
      const found = tokenOptions.find((o) => o.value === val);
      if (found) return found;
    }
    return tokenOptions[0] ?? FALLBACK_TOKEN;
  })();

  return (
    <div className="pp-graphs-filters">
      <Select
        values={tokenOptions}
        defaultValue={defaultValue}
        onChange={setSelectedToken}
        label=""
        className="pp-graphs-filters-token"
        disabled={!account}
      />

      <div className="divide-filters" />

      <ReportFilterButtons
        titleFilter=""
        dataArr={RANGE_OPTIONS.map((o) => ({ value: o.value, label: o.name, isVisible: true }))}
        selected={selectedRange}
        setSelected={setSelectedRange}
        disabled={!account}
        classNames="pp-graphs-filters-range"
        disableBorder
      />

      <div className="divide-filters" />

      <ReportFilterButtons
        titleFilter=""
        dataArr={RISK_TOKEN_LIST}
        selected={riskTokenType}
        setSelected={setRiskTokenType}
        disabled={!account}
        classNames="pp-graphs-filters-risk-token-type"
        disableBorder
      />
    </div>
  );
};
